import React, { lazy } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { FallbackProps } from 'react-error-boundary';

import { Loading } from '@components/shared';
import PageError from '@components/shared/PageError';
import AsyncBoundary from '@src/components/shared/AsyncBoundary';
import { APP_HOME_PATH, MAIN_PATH } from '@src/constants/constant';
import SettingsMy from '@src/views/setting/SettingMy';

const AIInsightKeyword = lazy(
  () => import('@views/aiInsight/AIInsightKeyword'),
);
import '@views/aiInsight/style.scss';

const RealtimeKeyword = lazy(
  () => import('@views/realtimeKeyword/RealtimeKeyword'),
);
import '@views/realtimeKeyword/style.scss';

const AIReportKeyword = lazy(() => import('@views/aiReport/AIReportKeyword'));
import '@views/aiReport/style.scss';

const IssueTable = lazy(() => import('@views/issueTable/IssueTable'));
import '@views/issueTable/style.scss';
import { Redirect } from '@src/components/shared/Redirect';

export const AppViews = () => {
  const location = useLocation();

  return (
    <AsyncBoundary
      ErrorFallback={(fallbackProps: FallbackProps) => (
        <PageError fallbackProps={fallbackProps} />
      )}
      SuspenseFallback={<Loading cover="content" />}
      resetKeys={[location.pathname]}
    >
      <Routes>
        <Route path="/realtime/*" element={<RealtimeKeyword />} />
        <Route path="/ai-insight/*" element={<AIInsightKeyword />} />
        <Route path="/ai-report/*" element={<AIReportKeyword />} />
        <Route path="/issue-table" element={<IssueTable />} />
        <Route path="/my" element={<SettingsMy />} />
        <Route path="*" element={<Redirect />} />
      </Routes>
    </AsyncBoundary>
  );
};

export default React.memo(AppViews);
